import { IconButton, Tooltip } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { useIntl } from 'react-intl';

/**
 * The way back to the worklist, as it appears in the header: an arrow between
 * the logo and the patient card, named for its destination by its tooltip and
 * accessible name.
 *
 * Presentation only. Two things trigger a return and they are not the same
 * act — with a patient loaded it closes that patient and is confirmed, with
 * none there is nothing to discard — so each owns its own handler while both
 * look and read identically. A user should not have to notice which case they
 * are in to recognise the control.
 */
export default function ReturnToListButton({
    onClick,
}: {
    onClick: () => void;
}) {
    const intl = useIntl();
    const label = intl.formatMessage({ id: 'backToPatientList' });

    return (
        <Tooltip title={label}>
            <IconButton
                size="small"
                onClick={onClick}
                aria-label={label}
                data-testid="return-to-patient-list"
            >
                <ArrowLeft size={18} />
            </IconButton>
        </Tooltip>
    );
}
